import { getPaginationSchema } from 'src/components/form/zod-schemas';
import { useNow } from 'src/hooks/use-now';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { useAuctionLivePageParams } from 'src/pages/transport/network-points/details/point-details/auction-live-table';
import { getTradeProposalsPageParamsSchema } from 'src/pages/transport/secondary-trading/overview/tso/schema';

const favouriteNetworkPointsSchema = getPaginationSchema({ pageSize: 5 });

export function useDashboardPageParams() {
  const now = useNow();

  const favouriteNetworkPoints = usePageParamsFromSchema(
    favouriteNetworkPointsSchema,
    { groupPrefix: 'favouriteNetworkPoints' }
  );

  const auctionLive = useAuctionLivePageParams();

  const ownTradeProposals = usePageParamsFromSchema(
    getTradeProposalsPageParamsSchema(now, { pageSize: 5 }),
    {
      groupPrefix: 'ownTradeProposals',
    }
  );

  const proposalsFavouriteNetworkPoint = usePageParamsFromSchema(
    getTradeProposalsPageParamsSchema(now, { pageSize: 5 }),
    {
      groupPrefix: 'proposalsFavouriteNetworkPoint',
    }
  );

  return {
    favouriteNetworkPoints,
    auctionLive,
    ownTradeProposals,
    proposalsFavouriteNetworkPoint,
  };
}

export type DashboardPageParams = ReturnType<typeof useDashboardPageParams>;
